export class ListaSolicitante {
  itens: ItemSolicitante[];
}

export class ItemSolicitante {
  id: number;
  nome: string;
  documento: string;
  tipoDocumento: number;
  telefone: string;
}
